var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHamburgerMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "custom/24/hamburger-menu"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M23.2969 14.8004C23.6987 14.8004 24 15.2379 24 15.6754C23.9998 16.1128 23.6984 16.5504 23.1963 16.5504H0.803711C0.401997 16.5504 0.000224129 16.1128 0 15.6754C0 15.2379 0.401884 14.8004 0.803711 14.8004H23.2969ZM23.2002 9.1002C23.6001 9.10034 24 9.53777 24 9.9752C23.9999 10.4126 23.5995 10.8502 23.0996 10.8502H0.799805C0.399926 10.8501 0.000111555 10.4126 0 9.9752C0 9.53777 0.39987 9.10034 0.799805 9.1002H23.2002ZM23.2969 3.4C23.6987 3.40005 24 3.83753 24 4.275C24 4.7125 23.6986 5.15 23.1963 5.15H0.803711C0.401884 5.15 0 4.7125 0 4.275C7.98357e-09 3.8375 0.401884 3.4 0.803711 3.4H23.2969Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHamburgerMenu);
export default __webpack_public_path__ + "static/media/icon-hamburger-menu.40f261e72b33a4b03379bf1fb234b52d.svg";
export { ForwardRef as ReactComponent };